// extracted by css-extract-rspack-plugin
export default {"cartWrapper":"cart-wrapper--HUjhnXX_XFYrJppF","cartPlaceholder":"cart-placeholder--nAhfIuRKSArFywhJ","cartPlaceholderIconWrapper":"cart-placeholder-icon-wrapper--anLJztvekQVQJdsF"};